import axios from 'axios';
import storage from '@/utils/storage';

const API_BASE_URL = 'https://nektar.e-solutions.uz/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false,
});

// Request interceptor - token qo'shish
api.interceptors.request.use(
  (config) => {
    const token = storage.get('token');
    console.log('API Request:', config.method.toUpperCase(), config.url);
    console.log('Token from storage:', token);
    
    if (token) {
      // Token ni to'g'ri formatda qo'shish
      config.headers.Authorization = `Bearer ${token}`;
      console.log('Authorization header added:', config.headers.Authorization);
    } else {
      console.warn('No token found in storage');
    }
    
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.config.url, response.status);
    return response;
  },
  (error) => {
    console.error('API Error:', error.response?.status, error.response?.data);
    
    if (error.response?.status === 401) {
      console.log('Token expired or invalid, clearing storage');
      storage.remove('token');
      storage.remove('user');
      
      // Redirect to login if not already there
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;